import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Typography } from 'interfaces/typography';
import { 
    selectSavedDispositions,
    selectHasUnsavedChanges
} from 'lib/redux/settings/platformDispositionsSlice';

export function SavedDispositionsDisplay() {
    const platform = useSelector((state: RootState) => state.autodialerSettings.selectedPlatform);
    const savedDispositions = useSelector(selectSavedDispositions(platform!));
    const hasUnsavedChanges = useSelector(selectHasUnsavedChanges(platform!));

    // Only show if there are saved dispositions and they differ from current
    if (savedDispositions.length === 0 || !hasUnsavedChanges) {
        return null;
    }

    return (
        <div className="p-4 bg-green-50 border border-green-200 rounded-md">
            <Typography variant="mediumParagraph" fontWeight="600" color="#065F46" className="mb-2">
                Last Saved Dispositions:
            </Typography>
            <div className="flex flex-wrap gap-2">
                {savedDispositions.map((disposition: string, index: number) => (
                    <div key={index} className="px-3 py-1 bg-green-100 border border-green-300 rounded-full">
                        <Typography variant="smallParagraph" color="#065F46">
                            {disposition}
                        </Typography>
                    </div>
                ))}
            </div>
        </div>
    );
}